export const environment = {
  production: true,
  buildNo:202603052223,
  version: '2.0.1',
  baseUrl: 'https://ws.epsv2.spientsyserv.com',
  assetsUrl: 'https://epsv2.spientsyserv.com/resources',
  assetsPosAdsPath: '/ads/pos',
  userId: 'epsv2',
  password: 'epsProdPass123#@!',
  appKey: "3b83c3b6b69ae6907b892320bc3d8087"
};
/**
 * passkey 3b83c3b6b69ae6907b892320bc3d8087
 */
